export const OrderTableFilter = {
  title: 'Ordenar Por:',
  supplierOrderCode: 'Nº de pedido BO',
  orderDate: 'Data de Criação Pyxis',
  availableDate: 'Data de Disponibilidade',
  palletTotal: 'Peso Total',
  volumeTotal: 'Volume Total',
  supplyOrderState: 'Estado'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/OrderTableFilter.js